import React, { useEffect } from 'react';
import { View, ScrollView, Alert } from 'react-native';
import { Card } from 'react-native-paper';
import { SafeAreaView } from 'react-native-safe-area-context';
import { CheckBox } from 'react-native-elements/dist/checkbox/CheckBox';
import { useDispatch, useSelector } from 'react-redux';

import styles from './styles';
import { AppHeader } from '../../../../components/common';
import { CompanyActions } from '../../../../redux/reducers/companyReducer';
import { appColors } from '../../../../assets/styles/global';
import { AppText, AppButton } from '../../../../components/form';

export default function selectDateLive({ navigation }) {
  const dispatch = useDispatch();
  const { companySignUp, availablePlans } = useSelector((state) => state.company);
  const {
    segunda, terca, quarta, quinta, sexta, sabado, domingo,
  } = companySignUp;
  const selectedPlan = availablePlans.find((item) => item.id_plano === companySignUp.id_plano);
  const classLimit = selectedPlan.qtd_aulas_mes;
  const planName = selectedPlan.plano;
  const currentClassCount = (segunda + terca + quarta + quinta + sexta + sabado + domingo) * 4;

  const handlePressDay = (day) => {
    if (companySignUp[day] === 0) {
      if (currentClassCount + 4 <= classLimit) {
        dispatch({ type: CompanyActions.UPDATE_SIGNUP, companySignUp: { ...companySignUp, [day]: companySignUp[day] === 1 ? 0 : 1 } });
      } else {
        Alert.alert('Atenção', 'Com os dias escolhidos já atinge o limite de aulas por mes. Se deseja este dia, desmarque algum dia e tente de novo.');
      }
    } else {
      dispatch({ type: CompanyActions.UPDATE_SIGNUP, companySignUp: { ...companySignUp, [day]: companySignUp[day] === 1 ? 0 : 1 } });
    }
  };
  useEffect(() => {
    dispatch({
      type: CompanyActions.UPDATE_SIGNUP,
      companySignUp: {
        ...companySignUp, segunda: 0, terca: 0, quarta: 0, quinta: 0, sexta: 0, sabado: 0, domingo: 0, horario: '',
      },
    });
  }, []);
  const getHours = () => {
    const hours = [];
    for (let i = 7; i <= 19; i++) {
      hours.push(`${i < 10 ? `0${i}` : i}:00`);
    }
    return (
      hours.map((hour, index) => (
        <AppButton
          key={`hour-${index}`}
          label={hour}
          style={[styles.buttonBadge, companySignUp.horario === hour && styles.buttonBadgeSelected]}
          labelStyle={styles.textBadge}
          onPress={() => dispatch({ type: CompanyActions.UPDATE_SIGNUP, companySignUp: { ...companySignUp, horario: companySignUp.horario === hour ? '' : hour } })}
        />
      ))
    );
  };
  return (
    <>
      <AppHeader navigation={navigation} hasBack title={planName} />
      <SafeAreaView style={styles.viewBase}>
        <ScrollView style={styles.scroll}>
          <Card style={styles.cardCalendar}>
            <AppText style={styles.TitleCalendar}>Selecione {classLimit/4} dias da Semana</AppText>
            {/* <AppText style={styles.textSubTitle}>{`Você pode escolher até ${classLimit / 4} dias por semana`}</AppText> */}
            {/* <AppText style={styles.textSubTitle}>{`Aulas escolhidas: ${currentClassCount} aprox.`}</AppText>/ */}
            <View style={{ flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between' }}>
              <CheckBox title={<AppText style={styles.textCheck}>Segunda</AppText>} containerStyle={styles.check} checkedColor={appColors.primary} checked={companySignUp.segunda === 1} onPress={() => handlePressDay('segunda')} />
              <CheckBox title={<AppText style={styles.textCheck}>Terça</AppText>} containerStyle={styles.check} checkedColor={appColors.primary} checked={companySignUp.terca === 1} onPress={() => handlePressDay('terca')} />
              <CheckBox title={<AppText style={styles.textCheck}>Quarta</AppText>} containerStyle={styles.check} checkedColor={appColors.primary} checked={companySignUp.quarta === 1} onPress={() => handlePressDay('quarta')} />
              <CheckBox title={<AppText style={styles.textCheck}>Quinta</AppText>} containerStyle={styles.check} checkedColor={appColors.primary} checked={companySignUp.quinta === 1} onPress={() => handlePressDay('quinta')} />
              <CheckBox title={<AppText style={styles.textCheck}>Sexta</AppText>} containerStyle={styles.check} checkedColor={appColors.primary} checked={companySignUp.sexta === 1} onPress={() => handlePressDay('sexta')} />
              <CheckBox title={<AppText style={styles.textCheck}>Sábado</AppText>} containerStyle={styles.check} checkedColor={appColors.primary} checked={companySignUp.sabado === 1} onPress={() => handlePressDay('sabado')} />
              <CheckBox title={<AppText style={styles.textCheck}>Domingo</AppText>} containerStyle={styles.check} checkedColor={appColors.primary} checked={companySignUp.domingo === 1} onPress={() => handlePressDay('domingo')} />
            </View>
          </Card>
          <Card style={styles.card}>
            <View style={styles.cardContent}>
              <AppText style={styles.TitleCalendar}>Horários:</AppText>
              <View style={styles.groupButtonsHours}>{ getHours() }</View>
            </View>
            <AppButton disabled={currentClassCount === 0 || companySignUp.horario === ''} label="AVANÇAR" style={styles.nextButton} labelStyle={styles.textBadge} onPress={() => navigation.navigate('Checkout: Pagamento - Live')} />
          </Card>
        </ScrollView>

      </SafeAreaView>
    </>
  );
}
